exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "h1[data-v-63b08ba8]{font-size:200px;font-family:Courgette,cursive;color:#8f8e8c;text-align:center;margin-bottom:1px;text-shadow:10px 3px 6px #eee}", "", {"version":3,"sources":["/Users/oila/Desktop/APP项目组/H5项目/open-platform-vue/src/views/NotFoundView.vue"],"names":[],"mappings":"AACA,oBACE,gBAAiB,AACjB,8BAAkC,AAClC,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,6BAA+B,CAChC","file":"NotFoundView.vue","sourcesContent":["\nh1[data-v-63b08ba8] {\n  font-size: 200px;\n  font-family: 'Courgette', cursive;\n  color: #8f8e8c;\n  text-align: center;\n  margin-bottom: 1px;\n  text-shadow: 10px 3px 6px #eee;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63b08ba8","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/views/NotFoundView.vue
// module id = 335
// module chunks = 16